import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faLock } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

/**
 * The banner shown above the sequence canvas while a campaign is locked (PREC-3786). It states the
 * restriction in one line; the "Why?" button opens {@link CampaignLockModal} with the full
 * explanation and the way out.
 */
export const CampaignLockBanner: FunctionComponent<{ onExplain: () => void }> = ({ onExplain }) => {
	const { t } = useTranslation();

	return (
		<div
			className="flex items-center gap-3 bg-white border border-border-light border-l-[3px] border-l-status-warning rounded-[10px] px-3.5 py-3 mb-4"
			data-testid="campaign-lock-banner"
		>
			<div className="w-8 h-8 shrink-0 rounded-lg bg-status-warning-light text-status-warning flex items-center justify-center">
				<Icon className="w-4 h-4" icon={faLock} />
			</div>
			<div className="flex-1 min-w-0">
				<p className="text-[13px] font-semibold leading-tight">
					{t("campaignLockExplainer.bannerTitle")}
				</p>
				<p className="text-xs text-text-meta leading-snug mt-0.5">
					{t("campaignLockExplainer.bannerText")}
				</p>
			</div>
			<Button
				color={ButtonColor.ACTION_SECONDARY}
				size={ButtonSize.XS}
				title={t("campaignLockExplainer.why")}
				type="button"
				onClick={onExplain}
			/>
		</div>
	);
};
